import { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { config, getInitialData } from "../puck/config";
import { Config, resolveAllData } from "@measured/puck";
import { useWebsiteContext } from "../context/website";

export const useData = ({ path }: { path: string }) => {
  const { websitePages, websiteDataLoading } = useWebsiteContext();
  const initialData = useMemo(() => getInitialData(websitePages), [websitePages]);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(initialData[path]);
  const [resolvedData, setResolvedData] = useState(data);

  useEffect(() => {
    const ResolvePuckData = async () => {
      setLoading(true);
      try {
        const page = websitePages.find(page => page.link === path);
        const actualData = page?.data ? JSON.parse(page.data) : initialData[path] || undefined;
        const resolved = await resolveAllData(actualData, config as Config);
        setData(actualData);
        setResolvedData(resolved);
      } catch (e) {
        setData(undefined);
        setResolvedData(undefined);
      }
      setLoading(false);
    }
    if (!websiteDataLoading) {
      ResolvePuckData();
    }
  }, [websitePages, path, websiteDataLoading]);

  return {
    data,
    resolvedData,
    key: path,
    loading
  };
};